import * as React from 'react';
import withStyles from 'react-jss';
import { CssType, ThemeType } from '../../theming/jssTypes';
import { WarningTwoTone } from '@ant-design/icons';
import { humanize } from '../../utils/utils';
import Modal from 'src/design-system/components/atoms/Modal/Modal';
import FixedHeaderTable from 'src/design-system/components/molecules/FixedHeaderTable/FixedHeaderTable';
import Button from 'src/design-system/components/atoms/Button/Button';
import Typography from 'src/design-system/components/atoms/Typography/Typography'
import { useTheme } from 'src/theming/useTheme';

const styles = (theme: ThemeType): CssType => ({
  confirmationModal: {
    '& .ant-modal-body': {
      padding: theme.spacing[0],
    },
  },
  buttonRow: {
    padding: theme.spacing[1],
    display: 'flex',
  },
  buttonStyle: {
    width: '120px',
    margin: theme.spacing[1],
  },
  textStyle: {
    alignSelf: 'center',
    marginRight: 'auto',
    marginLeft: theme.spacing[3],
  },
  warningIconStyle: {
    fontSize: theme.typography.fontSize.lg,
  },
});

const ConfirmationModal = (props: any) => {
  const {
    classes,
    dataArray,
    isVisible,
    dataColumns,
    width,
    title,
    showFooterSection,
    footerText,
    primaryButtonText,
    onClickPrimaryButton,
    secondaryButtonText,
    onClickSecondaryButton,
    onModalClose,
  } = props;

  const theme = useTheme();

  const defaultColumns = [
    {
      title: 'Consignment Number',
      dataIndex: 'reference_number',
      width: '200px',
    },
    {
      title: 'Message',
      dataIndex: 'message',
    },
  ];

  const generateColumnForTable = () => {
    const columnData: object[] = [];
    if (dataArray == null || dataArray.length === 0) {
      return columnData;
    }
    const indexList = dataColumns ? dataColumns : defaultColumns;
    indexList.forEach((item: any) => {
      const itemToPush = {
        title: item.title,
        dataIndex: item.dataIndex,
        key: item.key,
        width: item.width,
        render: (_text: any, record: any) => {
          return record[item.dataIndex]
            ? humanize(record[item.dataIndex])
            : null;
        },
      };

      columnData.push(itemToPush);
    });

    return columnData;
  };

  const handleModalClose = () => {
    onModalClose();
  };

  return (
    <Modal
      title={
        <div>
          <WarningTwoTone
            twoToneColor={theme.color.semantic.brand.danger.primary}
            className={classes.warningIconStyle}
          />{' '}
          {title || 'Confirmation'}
        </div>
      }
      className={classes.confirmationModal}
      visible={isVisible}
      onCancel={handleModalClose}
      destroyOnClose
      maskClosable={false}
      width={width || 600}
      okText="Ok"
      footer={null}
    >
      <div>
        <FixedHeaderTable
          {...({ pagination: false } as any)}
          scroll={{ y: '400px' }}
          columns={generateColumnForTable()}
          dataSource={dataArray}
          rowKey={(record: any) => record['row_num']}
        />
      </div>
      {showFooterSection ? (
        <div className={classes.buttonRow}>
          <Typography.Text className={classes.textStyle}>
            {' '}
            {footerText}{' '}
          </Typography.Text>
          <Button
            type="primary"
            className={classes.buttonStyle}
            onClick={onClickPrimaryButton}
          >
            {' '}
            {primaryButtonText}{' '}
          </Button>
          <Button
            type="secondary"
            className={classes.buttonStyle}
            onClick={onClickSecondaryButton}
          >
            {' '}
            {secondaryButtonText}{' '}
          </Button>
        </div>
      ) : null}
    </Modal>
  );
};

export default withStyles(styles, { injectTheme: true })(ConfirmationModal);
